export default __webpack_public_path__ + "static/media/planet-2.3afd16a4.svg";